<template>
  <div>
    <div class="name align-center">
      <h5>{{ technician.text }}</h5>
      <p class="header-p">C: {{ accounting.formatMoney(technician.data.commission, '£', 2)  }}</p>
      <p class="header-p">T: {{ accounting.formatMoney(technician.data.turnover, '£', 2) }}</p>
      <p class="header-p">{{ technician.data.region }}</p>
      <v-btn @click="emitPostCode(technician.data.region)" v-if="selectPostCode" color="blue"
             class="mb-2 white--text" small>
        <v-icon>mdi-map</v-icon>
      </v-btn>
      <v-btn @click="emitTechForEmail(technician.data)" v-if="selectTechnician" color="blue"
             class="mb-2 white--text" small>
        <v-icon>mdi-mail</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>

import EventBus from "@/EventBus";
import accounting from 'accounting';

export default {
  props: {
    technician: {
      type: Object,
      default: () => {
      }
    },
    selectPostCode: {
      type: Boolean,
      default: true
    },
    selectTechnician: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      accounting: accounting,
    }
  },
  methods: {
    emitPostCode(postcode) {
      EventBus.$emit("postcode", postcode);
    },
    emitTechForEmail(technician) {
      EventBus.$emit("technician", technician);
    }
  }
};
</script>

<style>
.name {
  color: #fff;
  text-align: center;
}

.header-p {
  margin-bottom: 2px !important;
}
</style>
